module.exports = __webpack_public_path__ + "static/media/logowhite.d54f1216.png";